<app-top-header *ngIf="!popup"></app-top-header>
<app-navbar *ngIf="!popup"></app-navbar>
<app-loader></app-loader>
<router-outlet></router-outlet>
<notifier-container></notifier-container>
<app-footer *ngIf="!popup"></app-footer>
<ngx-scrolltop></ngx-scrolltop>
<mini-cart></mini-cart>